export class GlobalFooter {

	constructor (common) {
		this.common = common;
	}
}
